import * as React from "react";
import { Text, Flex, TagLabel, Box } from "@draftkings/arena-web";
import { handleBetDetailsImageError } from "../../../../helpers";
import { CrossOutTitleSelections } from "../CrossOutTitleSelections";
import { FinalScore } from "../FinalScore";
export const BetDetails = React.memo(
// eslint-disable-next-line complexity
function BetDetails(props) {
    // Using null for useRef is a better practice than using undefined
    // eslint-disable-next-line no-null/no-null
    const iconRef = React.useRef(null);
    const { purchaseId, title, subtitle, statusLabel, statusVariant, newOdds, iconUrl, tag = undefined, onClick, originalSelections, finalScore, selectionId, finalScoreResult, originalDisplayOdds, newOddsVariant = "betTitle", isBetOverMaxAmount = false, } = props;
    const iconStyles = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "22px",
        height: "22px",
    };
    const clickableAreaStyles = typeof onClick === "function" ? {
        cursor: "pointer",
    } : {};
    return React.createElement("div", { "data-testid": `bet-details-clickable-area-${purchaseId}`, "data-test-id": `bet-details-clickable-area-${purchaseId}`, onClick: onClick, style: clickableAreaStyles },
        React.createElement(Flex, { justifyContent: "space-between", testId: 'bet-details' },
            React.createElement(Flex, null,
                iconUrl && React.createElement(Box, { testId: `bet-details-icon-${purchaseId}`, position: "relative", width: "42px", height: "42px", marginRight: "$s2", borderRadius: "100%", backgroundColor: "$gray700" },
                    React.createElement("img", { src: iconUrl, style: iconStyles, ref: iconRef, alt: "", 
                        // Using an arrow function here so we are able to pass the icon ref to the handler.
                        // eslint-disable-next-line react/jsx-no-bind
                        onError: () => handleBetDetailsImageError(iconRef) })),
                React.createElement(Flex, { flexDirection: "column", overflow: 'hidden', marginBottom: "16px" },
                    React.createElement(Box, { marginBottom: 6 },
                        tag,
                        React.createElement(Text, { testId: `bet-details-title-${purchaseId}`, variant: "betTitle", as: "span" },
                            React.createElement(CrossOutTitleSelections, { originalSelections: originalSelections }),
                            title),
                        newOdds
                            ? React.createElement(Box, { as: "span" },
                                React.createElement(Text, { as: "span", testId: `bet-details-original-displayOdds-${purchaseId}`, variant: isBetOverMaxAmount ? "betTitle" : "originalOdds" }, originalDisplayOdds),
                                React.createElement(Text, { as: "span", testId: `bet-details-boosted-displayOdds-${purchaseId}`, variant: isBetOverMaxAmount ? "betOverMaxOdds" : newOddsVariant }, newOdds))
                            : React.createElement(Text, { testId: `bet-details-displayOdds-${purchaseId}`, variant: "betTitle", as: "span" }, originalDisplayOdds)),
                    React.createElement(Text, { testId: `bet-details-subtitle-${purchaseId}`, variant: "betTextHighlight", as: "span" }, subtitle),
                    finalScore && selectionId && React.createElement(FinalScore, { selectionId: selectionId, finalScore: finalScore, result: finalScoreResult }))),
            statusVariant && React.createElement(TagLabel, { testId: `bet-details-status-${purchaseId}`, variant: statusVariant }, statusLabel)));
});
//# sourceMappingURL=BetDetails.js.map